import type { IFreezeFanExcpt } from '@module/apis/client-side/chat/type';

interface FreezeInfo {
  enable: boolean;
  managerExcpt?: 'Y' | 'N' | '';
  fanExcpt?: IFreezeFanExcpt | '';
}

interface FreezeFanInfo {
  isRoomMaster: boolean;
  isManager: boolean;
  rank: number;
  level: number;
}

/**
 * roomFreeze(채팅창 잠금) 상태에서 해당 시청자가 채팅을 보낼 수 있는지 판정한다.
 *
 * 순수 함수 — 호출처에서 fanInfo를 최신 토큰 정보(level/rank/isManager)로 갱신한 뒤 넘긴다.
 * 동작은 useChatComposer의 기존 freeze 게이팅 분기와 동일하다.
 */
const resolveFreezeChatPermission = (roomFreezeInfo: FreezeInfo | undefined, fanInfo: FreezeFanInfo): boolean => {
  // freeze 비활성: 항상 허용
  if (!roomFreezeInfo?.enable) return true;

  const fanExcpt = roomFreezeInfo.fanExcpt;

  // 방장 채팅 허용
  if (fanInfo.isRoomMaster) return true;

  // 팬 예외 N이 아닌 상태(팬 예외)이면 열혈팬 rank 1~10 채팅 허용
  if (fanExcpt !== 'N' && fanInfo.rank >= 1 && fanInfo.rank <= 10) return true;

  // 팬 예외 N이 아니고(빈 문자열도 아니고) 팬이면서 팬 예외 레벨보다 팬 레벨이 높으면 채팅 허용
  // 팬예외 레벨 1(브론즈)가 제한이고 시청자가 2(실버)라면 채팅 허용
  if (fanExcpt && fanExcpt !== 'N' && Number(fanExcpt) <= Number(fanInfo.level)) return true;

  // 내가 매니저이면서 채팅금지에서 매니저가 예외인 경우 채팅 허용
  if (roomFreezeInfo.managerExcpt === 'Y' && fanInfo.isManager) return true;

  // 그 외 채팅 불가
  return false;
};

export default resolveFreezeChatPermission;
